module.exports = __webpack_public_path__ + "Lato-Thin.454421e7b2b8aaee2980.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Thin.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Thin.ttf
// module chunks = styles